/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateReviewDto } from '../models/CreateReviewDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ClientAppReviewsService {
    /**
     * Submit a review for an expert
     *
     * Allows a client to submit a rating and optional review text for an expert.
     *
     * **Validations:**
     * - Expert must exist
     * - Client must have at least one completed session with the expert
     * - Only one review per expert is allowed for the same client
     * - Rating must be between 1 and 5
     *
     * **Side effects:**
     * - Expert's average_rating and total_ratings are recalculated
     *
     * @param requestBody
     * @returns any Review submitted successfully
     * @throws ApiError
     */
    public static clientAppReviewsControllerCreateReviewV1(
        requestBody: CreateReviewDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/client-app/reviews',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                403: `No completed session found for this expert`,
                404: `Expert not found`,
                409: `Duplicate review for this expert`,
            },
        });
    }
}
